import isUnauthorizedResponse from '../isUnauthorizedResponse';
function getGlobalReauthPromise() {
    if (typeof window !== 'undefined') {
        return window.__TI_REAUTH_PROMISE__;
    }
}
export default function createUnauthorizedApiResponseHandler(serviceFunc, ...serviceFuncArgs) {
    return async (unauthorizedHandler) => {
        await getGlobalReauthPromise();
        return serviceFunc(...serviceFuncArgs).catch(async (apiError) => {
            if (isUnauthorizedResponse(apiError)) {
                if (unauthorizedHandler) {
                    await getGlobalReauthPromise();
                    return unauthorizedHandler(apiError);
                }
            }
            throw apiError;
        });
    };
}
